import { Injectable } from "@angular/core";
import { RequestCRUD } from "src/app/shared/services/abstract/request-crud.service";
import { ResponseServiceModel } from "src/app/shared/models/response-service.model";
import { EnviromentGlobalService } from "src/app/shared/services/enviroment-global.service";
import {
  HttpClient,
  HttpEvent,
  HttpHeaders,
  HttpRequest,
} from "@angular/common/http";
import { retry } from "rxjs/operators";
import { Observable } from "rxjs";

@Injectable()
export class SancionService implements RequestCRUD<any, ResponseServiceModel> {
  private API_URL;

  constructor(
    private http: HttpClient,
    private enviromentGlobalService: EnviromentGlobalService
  ) {
    this.API_URL = enviromentGlobalService.apiUrl;
  }

  get(entry: any): import("rxjs").Observable<ResponseServiceModel> {
    throw new Error("Method not implemented.");
  }
  update(entry: any): import("rxjs").Observable<ResponseServiceModel> {
    throw new Error("Method not implemented.");
  }
  create(entry: any): import("rxjs").Observable<ResponseServiceModel> {
    throw new Error("Method not implemented.");
  }
  delete(entry: any): import("rxjs").Observable<ResponseServiceModel> {
    throw new Error("Method not implemented.");
  }

  getSancionesActuales(entry: any): Observable<ResponseServiceModel> {
    return this.http
      .get<ResponseServiceModel>(
        `${this.API_URL}/Sanciones/${entry.rnt_id}/GetByRnt`
      )
      .pipe(retry(2));
  }

  crearSancion(entry: any): Observable<HttpEvent<any>> {
    const input = new FormData();
    input.append("archivo", entry.archivo_send, entry.archivo_send.name);
    input.append("titulo", entry.titulo);
    input.append("fecha_inicio_sancion", entry.fecha_inicio_sancion);
    input.append("fecha_fin_sancion", entry.fecha_fin_sancion);
    input.append("motivo", entry.motivo);
    input.append("solicitud_id", entry.solicitud_id);
    input.append("rnt_id", entry.rnt_id);
    const uploadReq = new HttpRequest(
      "POST",
      `${this.API_URL}/Sanciones/Crear/${entry.codigo_camara}`,
      input
    );
    return this.http.request<HttpEvent<any>>(uploadReq).pipe(retry(2));
  }

  eliminarSancion(entry: any): Observable<HttpEvent<any>> {
    const input = new FormData();
    input.append("archivo", entry.archivo_send, entry.archivo_send.name);
    input.append("motivo", entry.motivo);
    input.append("camara_id", entry.camara_id);
    input.append("sancion_id", entry.sancion_id);
    input.append("solicitud_id", entry.solicitud_id);
    const uploadReq = new HttpRequest(
      "PUT",
      `${this.API_URL}/sanciones/CambiarEstadoSancion`,
      input
    );
    return this.http.request<HttpEvent<any>>(uploadReq).pipe(retry(2));
  }

  getConsultaPrestador(entry: any): Observable<ResponseServiceModel> {
    return this.http
      .get<ResponseServiceModel>(
        `${this.API_URL}/Prestador/${entry.codigo_rnt}/GetPrestadorByRnt`
      )
      .pipe(retry(2));
  }
}
